import React, { useState, useRef, useEffect, ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DropdownMenuProps } from "./DropdownType";
import { Button } from "components/Button/Button";



export const DropdownMenu = ({ trigger, items, className }: DropdownMenuProps) => {

    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);






    return <div className={` relative  inline-block ${className} `}>
        <div ref={menuRef}>
            <DropdownMenuTrigger onClick={() => setOpen((prev) => !prev)} >
                {trigger}
            </DropdownMenuTrigger>
            <AnimatePresence>
                {open && (
                    <DropdownMenuContent onClose={() => setOpen(false)}>
                        {items?.filter(a => a)?.map((item, index) => <DropdownMenuItem onClick={item?.onClick} key={index} >
                            {item?.icon}
                            {item?.label}
                        </DropdownMenuItem>)}
                    </DropdownMenuContent>
                )}
            </AnimatePresence>
        </div>
    </div>;
};

export const DropdownMenuTrigger = ({
    children,
    onClick
}: {
    children: ReactNode;
    onClick: () => void
}) => {
    return (
        <Button
            variant="outline"
            onClick={onClick}
            className=" inline-block bg-white/70 backdrop-blur-lg    focus:outline-none"
        >
            {children}
        </Button>
    );
};

// Content with animation
export const DropdownMenuContent = ({
    children,
    onClose,
}: {
    children: ReactNode;
    onClose?: () => void;
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9, y: -4 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: -4 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
            className="absolute  mt-2   overflow-hidden bg-white border border-primary-200 rounded-md shadow-lg z-[10000] origin-top-right"
            onClick={onClose}
        >

            {children}

        </motion.div>
    );
};

export const DropdownMenuItem = ({
    children,
    onClick,
}: {
    children: ReactNode;
    onClick?: () => void;

}) => (
    <motion.button
        whileTap={{ scale: 0.97 }}
        onClick={onClick}
        className={`w-full hover:bg-primary-700 hover:text-white  duration-300 flex text-primary-700 justify-start gap-2 items-center  text-start px-3 py-2 text-sm cursor-pointer`}
    >
        <div className=" w-full h-full min-w-[100px] flex gap-2 items-center " >{children}</div>
    </motion.button>
);

// Separator
export const DropdownMenuSeparator = () => (
    <div className="h-px bg-primary-200 my-1" />
);
